export const PRIVACY_POLICY_URL =
  'https://www.iubenda.com/privacy-policy/90550491'
export const COOKIE_POLICY_URL =
  'https://www.iubenda.com/privacy-policy/90550491/cookie-policy'
export const TERMS_AND_CONDITION_URL =
  'https://www.iubenda.com/terms-and-conditions/90550491'
export const CONTACT_URL = 'mailto:support@resactly.com'

export const FACEBOOK_PAGE_URL =
  'https://www.facebook.com/people/Resactly/100087837874001/'
export const INSTAGRAM_PAGE_URL = 'https://www.instagram.com/resactly/'

export const OKAO_LABS_URL = 'https://www.okaolabs.co'

// ChatGPT developer-mode install (interim path while the official plugin listing is in review).
// The MCP server intentionally uses No auth — do not add credentials to these instructions.
export const RESACTLY_MCP_URL = 'https://svc.resactly.com/mcp'
export const CHATGPT_WEB_URL = 'https://chatgpt.com'
export const COPY_RIGHT_PREFIX = `© ${new Date().getFullYear()} `
// Copyright holder is OKAO Inc. until the Resactly legal transfer to OKAO Labs Inc. completes —
// do not flip this back to OKAO Labs Inc. before then. The name still links to OKAO_LABS_URL.
export const COPY_RIGHT_COMPANY = 'OKAO Inc.'
export const COPY_RIGHT_SUFFIX = ' All rights reserved.'

export const DEFAULT_CARD_IMAGE = '/logoLetter-resize.svg'
export const DEFAULT_AVATAR_IMAGE =
  'https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_960_720.png'

/**
 * Returns a non-empty string URL for TalkJS photoUrl, or undefined so the field can be omitted.
 * TalkJS requires photoUrl to be a non-empty string when provided; pass undefined to skip it.
 */
export function toTalkPhotoUrl(
  value: unknown,
  fallback?: string,
): string | undefined {
  const raw =
    typeof value === 'string' ? value : typeof fallback === 'string' ? fallback : ''
  const s = raw.trim()
  return s.length > 0 ? s : undefined
}

/**
 * The TalkJS conversation id for a group/dining session IS its group id.
 *
 * Backend contract (TalkJsService): conversations are matched by
 * `conversation.getId().equalsIgnoreCase(groupId)` for token issuance + unread counts — so the id
 * must equal the group id verbatim (no prefix, no character rewriting). The value is stable across
 * graduation (persistSession mutates the same row) and the session view receives the same value as
 * `sessionId`. Deriving the conversation id here in ONE place keeps the dining-session chat and the
 * saved-group chat pointed at a single conversation. A group id is a UUID, already a legal TalkJS id.
 */
export function groupConversationId(groupId?: string | null): string {
  return (groupId ?? '').trim()
}

export const WEB_NAV_HEIGHT = 94
export const avatarImages = [
  'https://img.freepik.com/free-photo/portrait-white-man-isolated_53876-40306.jpg',
  'https://t4.ftcdn.net/jpg/04/25/65/97/360_F_425659755_5BaLdNbbCtQbbiz1JNFBikshfiCWI5NE.jpg',
  'https://images.pexels.com/photos/614810/pexels-photo-614810.jpeg?cs=srgb&dl=pexels-simon-robben-55958-614810.jpg&fm=jpg',
  'https://images.rawpixel.com/image_800/czNmcy1wcml2YXRlL3Jhd3BpeGVsX2ltYWdlcy93ZWJzaXRlX2NvbnRlbnQvbHIvcm0zMjgtMzY2LXRvbmctMDhfMS5qcGc.jpg',
  'https://i.pinimg.com/736x/dc/c4/59/dcc459cef6213a9d5bf9fc2f17765ae4.jpg',
  'https://qodebrisbane.com/wp-content/uploads/2019/07/This-is-not-a-person-10-1.jpeg',
  'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTGmt7mgLLJbU_An415Sur0-Iq8kRKQzzAwCw&s',
  'https://t4.ftcdn.net/jpg/02/45/56/35/360_F_245563558_XH9Pe5LJI2kr7VQuzQKAjAbz9PAyejG1.jpg',
  'https://img.freepik.com/free-photo/close-up-portrait-handsome-smiling-young-man-white-t-shirt-looking-away-blurry-outdoor-nature_176420-6304.jpg',
]

export const MOBILE_NAV_HEIGHT = 72
export const MOBILE_SEARCH_HEIGHT = 48
export const MOBILE_APP_HEIGHT = 74

// Referral localStorage keys
export const PENDING_REFERRAL_CODE_KEY = 'pendingReferralCode'
export const PENDING_REFERRAL_CONTEXT_KEY = 'pendingReferralContext'
export const PENDING_REFERRAL_ATTRIBUTION_KEY = 'pendingReferralAttribution'
// Referral context value that routes the invitee into restaurant (not eater) onboarding.
export const RESTAURANT_SIGNUP_REFERRAL_CONTEXT = 'RESTAURANT_SIGNUP'

// Pending save menu intent (sessionStorage) – used to resume save after auth
export const PENDING_SAVE_MENU_INTENT_KEY = 'pendingSaveMenuIntent'

export const price = ['$', '$$', '$$$', '$$$$']

export const headingName = [
  {
    title: 'Wallet Friendly Restaurants',
    key: 'WALLET',
  },
  {
    title: 'Local Flavors To Explore',
    key: 'LOCAL',
  },
  {
    title: 'Top Rated Restaurants',
    key: 'TOPRATED',
  },
  {
    title: 'Must Try Cuisine Hotspots',
    key: 'MUSTTRY',
  },
]

export const DATE_FORMAT = 'YYYY-MM-DD'

export const DATE_RANGES = [
  { title: 'Last 2 days', value: 2 },
  { title: 'Last 7 days', value: 7 },
  { title: 'Last 10 days', value: 10 },
  { title: 'Last 30 days', value: 30 },
]

export const RESTAURANT_HEADER_WEB = 150
export const RESTAURANT_HEADER_MOBILE = 102
export const RESTAURANT_PAGE_LAYOUT_HEADER = 78

export const DRAWER_WIDTH_OPEN = '285px'
export const DRAWER_WIDTH_CLOSED = '100px'

// TODO: temp for mock data

export const SUITABLE_DIETARY_DATA =
  'Vegan, Vegetarian, Pescatarian, Flexitarian'
export const UNSUITABLE_DIETARY_DATA =
  'Omnivore,Carnivore,Vegetarian,Kosher,Gluten-Free'

export const CHART_COLORS = [
  '#9C640C',
  '#FF0000',
  '#00C49F',
  '#FFD700',
  '#FFA500',
  '#8000FF',
  '#3399FF',
  '#66CC00',
  '#008000',
  '#FF0090',
  '#FFC0CB',
]

export const socialPlatforms = ['instagram', 'facebook', 'tiktok', 'youtube']
export const followerOptions = [
  { label: '0 - 1k', value: '0-1000' },
  { label: '1k - 10k', value: '1000-10000' },
  { label: '10k - 50k', value: '10000-50000' },
  { label: '50k - 100k', value: '50000-100000' },
  { label: '100k - 500k', value: '100000-500000' },
  { label: '500k - 1m', value: '500000-1000000' },
  { label: '1m - 5m', value: '1000000-5000000' },
  { label: '5m - 10m', value: '5000000-10000000' },
  { label: '10m+', value: '10000000+' },
]
export const contentNicheList = [
  {
    label: 'Lifestyle',
    value: 'lifestyle',
  },
  {
    label: 'Fashion',
    value: 'fashion',
  },
  {
    label: 'Beauty',
    value: 'beauty',
  },
  {
    label: 'Travel',
    value: 'travel',
  },
  {
    label: 'Health & Fitness',
    value: 'health',
  },
  {
    label: 'Food & Drink',
    value: 'food',
  },
  {
    label: 'Art & Photography',
    value: 'art',
  },
  {
    label: 'Model',
    value: 'model',
  },
  {
    label: 'Comedy & Entertainment',
    value: 'comedy',
  },
  {
    label: 'Music & Dance',
    value: 'music',
  },
]
